import React, {useState} from "react";
import {Pocket} from "../logic/types";
import {TableCell, TableRow, Stack} from "@mui/material";
import PocketDetailsDialog from "./PocketDetailsDialog";

export type PocketListElementProps = {
  onChangedPocket: () => void
  onDeletedPocket: () => void
  pocket: Pocket
  index: number
  pockets: Array<Pocket>
  selectedMonth: Date
}

export default function PocketListElement(props: PocketListElementProps) {
  const [showPocketDetailsDialog, setShowPocketDetailsDialog] = useState(false)

  function getGoalString(): string {
    if (!props.pocket.goal) {
      return ''
    }
    const goalMoney = props.pocket.goal.money
    if (!props.pocket.goal.dueDate) {
      return `${goalMoney}`
    }
    const dueDate = new Date(props.pocket.goal.dueDate)
    const leftTime = dueDate.getTime() - props.selectedMonth.getTime()
    if (leftTime < 0) {
      return `${goalMoney} просрочено`
    }
    return `${goalMoney} до ${dueDate.toLocaleDateString()}\n(${Math.ceil(leftTime / (1000 * 60 * 60 * 24))} дн.)`
  }

  return (
    <>
      <TableRow onClick={() => setShowPocketDetailsDialog(true)}>
        <TableCell align="center">{props.index + 1}</TableCell>
        <TableCell align="center">{props.pocket.title}</TableCell>
        <TableCell align="center">{props.pocket.balance}</TableCell>
        <TableCell align="center">{getGoalString()}</TableCell>
      </TableRow>

      <PocketDetailsDialog
        pocket={props.pocket}
        show={showPocketDetailsDialog}
        onClose={() => setShowPocketDetailsDialog(false)}
        onChangedPocket={props.onChangedPocket}
        onDeletedPocket={props.onDeletedPocket}
        pockets={props.pockets}
        selectedMonth={props.selectedMonth}
      />
    </>
  );
}
